export default {"src":"/_next/static/media/email-icon-v2.afe86b43.svg","height":16,"width":16};